import { breadcrumb, startClientDiagnostics } from "./lib/diagnostics/client";

startClientDiagnostics();
export function onRouterTransitionStart(url: string) {
  breadcrumb({ category: "route", route: url, method: "navigate" });
}
